<!-- Filtro avanzado flotante superior -->
<app-advanced-filter #advFilter [fields]="advancedFilterFields" [showTrigger]="false"
    (filtersChange)="activeAdvancedFilters.set($event)">
</app-advanced-filter>

<!-- Cabecera estandarizada responsive -->
<app-page-header
    title="Gestión de Primas"
    mobileTitle="Primas"
    icon="fas fa-file-invoice-dollar"
    optionsLabel="Exportar"
    optionsIcon="fa fa-cog"
    [hasOptions]="true">
    <div headerOptions>
        @if (perm.hasCurrentAction('EXPORT_EXCEL')) {
        <a (click)="exportExcel()" class="dropdown-item d-none d-md-block">
            <i class="fa fa-file-excel me-2"></i> Exportar Primas Excel
        </a>
        }
        @if (perm.hasCurrentAction('EXPORT_PDF')) {
        <a (click)="exportPDF()" class="dropdown-item">
            <i class="fa fa-file-pdf me-2"></i> Exportar Primas PDF
        </a>
        }
        @if (perm.hasCurrentAction('ACCOUNT_BILLING_ALL')) {
        <div class="dropdown-divider d-none d-md-block"></div>
        <a (click)="openApsModal(apsMappingModal)" class="dropdown-item d-none d-md-block">
            <i class="fa fa-users me-2"></i> Aasinet - Cobros Personas
        </a>
        }
    </div>
</app-page-header>

<app-mobile-footer [visible]="appSettings.isMobile()">
    <ng-select [items]="parties()" bindLabel="name" bindValue="rut"
        class="mobile-footer-search"
        [ngModel]="selectedPartyRut()"
        (ngModelChange)="selectedPartyRut.set($event); applyFilters()"
        [clearable]="true"
        [dropdownPosition]="'top'"
        placeholder="Buscar socio...">
    </ng-select>
    <button type="button" class="btn btn-outline-secondary btn-sm mobile-footer-filter"
        [class.btn-outline-primary]="advFilter.activeFiltersCount() > 0"
        (click)="advFilter.toggleOpen()">
        <i class="fas fa-filter me-1"></i>Filtros
        @if (advFilter.activeFiltersCount() > 0) {
            <span class="badge bg-primary ms-1">{{ advFilter.activeFiltersCount() }}</span>
        }
    </button>
</app-mobile-footer>

    @if (!appSettings.isMobile()) {
        <!-- Panel de filtros Desktop -->
        <div class="panel p-3 mb-3 border-0 shadow-sm position-relative">
            <div class="row align-items-end g-3">
                <div class="col-md-2">
                    <label class="form-label fw-bold small text-uppercase text-muted">Desde</label>
                    <ng-select [items]="periods()" bindLabel="displayName" bindValue="id"
                        [ngModel]="selectedPeriodStartId()"
                        (ngModelChange)="selectedPeriodStartId.set($event); loadBillings(true)" [clearable]="false"
                        placeholder="Desde">
                    </ng-select>
                </div>
                <div class="col-md-2 ">
                    <label class="form-label fw-bold small text-uppercase text-muted">Hasta</label>
                    <ng-select [items]="filteredEndPeriods" bindLabel="displayName" bindValue="id"
                        [ngModel]="selectedPeriodEndId()" (ngModelChange)="selectedPeriodEndId.set($event); loadBillings()"
                        [clearable]="false" placeholder="Hasta">
                    </ng-select>
                </div>
                <div class="col-md-2">
                    <label class="form-label fw-bold small text-uppercase text-muted">Contabilización</label>
                    <ng-select [items]="accountedFilters" bindLabel="name" bindValue="slug"
                        [ngModel]="selectedAccounted()"
                        (ngModelChange)="selectedAccounted.set($event)" [clearable]="false"
                        placeholder="Contabilización">
                    </ng-select>
                </div>
                @if (!authService.isUserRole()) {
                <div class="col-md-3">
                    <label class="form-label fw-bold small text-uppercase text-muted">Entidad</label>
                    <ng-select [items]="entities()" bindLabel="name" bindValue="code" [ngModel]="selectedEntityCode()"
                        (ngModelChange)="selectedEntityCode.set($event); applyFilters()" [multiple]="true"
                        placeholder="Todas las Entidades">
                    </ng-select>
                </div>
                }
                <div class="col-md-3">
                    <label class="form-label fw-bold small text-uppercase text-muted">Socio</label>
                    <ng-select [items]="parties()" bindLabel="name" bindValue="rut" [ngModel]="selectedPartyRut()"
                        (ngModelChange)="selectedPartyRut.set($event); applyFilters()" [clearable]="true"
                        placeholder="Busqueda por Socio...">
                    </ng-select>
                </div>
            </div>
        </div>
    }

    @if (!appSettings.isMobile()) {
        <!-- Tabla Desktop -->
        <div class="panel p-3 mb-3 border-0 shadow-sm">
            <div class="col-12 table-data mb-3 ">
                <table class="table table-sm table-hover">
                    <thead>
                        <tr>
                            <th class="text-uppercase align-middle">
                                <div class="d-inline-flex align-items-center gap-1">
                                    <button type="button" class="filter-table-btn" (click)="advFilter.toggleOpen()" title="Filtros avanzados">
                                        <i class="fas fa-filter" [class.text-primary]="advFilter.activeFiltersCount() > 0"></i>
                                        @if(advFilter.activeFiltersCount() > 0) {
                                            <span class="filter-count-badge">{{ advFilter.activeFiltersCount() }}</span>
                                        }
                                    </button>
                                    <span>Entidad</span>
                                </div>
                            </th>
                            <th class="text-center text-uppercase">Estado</th>
                            <th class="text-uppercase">Socio</th>
                            <th class="text-center text-uppercase">Periodo</th>
                            <th class="text-uppercase">Patente</th>
                            <th class="text-end text-uppercase">Valor</th>
                            <th class="text-end text-uppercase">Prima</th>
                        </tr>
                    </thead>
                    <tbody>
                        @if(isLoading()) {
                        @for(i of [1,2,3,4,5,6]; track $index) {
                        <tr class="placeholder-glow">
                            <td class="align-middle"><span class="placeholder placeholder-sm col-8 bg-gray-500"></span></td>
                            <td class="align-middle text-center"><span class="placeholder placeholder-sm col-6 bg-gray-500"></span></td>
                            <td class="align-middle"><span class="placeholder placeholder-sm col-10 bg-gray-500"></span></td>
                            <td class="align-middle text-center"><span class="placeholder placeholder-sm col-6 bg-gray-500"></span></td>
                            <td class="align-middle"><span class="placeholder placeholder-sm col-7 bg-gray-500"></span></td>
                            <td class="align-middle text-end"><span class="placeholder placeholder-sm col-8 bg-gray-500"></span></td>
                            <td class="align-middle text-end"><span class="placeholder placeholder-sm col-7 bg-gray-500"></span></td>
                        </tr>
                        }
                        } @else {
                        @for(bill of filteredBillings(); track bill.id) {
                        <tr>
                            <td class="align-middle">
                                <span>{{ bill?.entityCode }}</span>
                            </td>
                            <td class="text-center align-middle">
                                @if(isBillingPartyAccounted(bill)) {
                                    <span class="badge bg-success" [title]="billingPartyAccountedTitle(bill)">Contabilizado</span>
                                } @else {
                                    <span class="badge bg-secondary">Pendiente</span>
                                }
                            </td>
                            <td class="align-middle w-25">
                                <span>{{ bill.party?.names }}</span>
                            </td>
                            <td class=" text-center align-middle ">
                                <span>{{ bill.year }}/{{ bill.period | number:'2.0-0' }}</span>
                            </td>
                            <td class="align-middle">
                                <span>{{ bill.vehicle?.plate || 'S/P' }}</span>
                            </td>
                            <td class="align-middle text-end w-25">
                                <span class=" small">{{ bill.vehicle?.commercialValue | number:'1.0-0':'es-CL' }}</span>
                            </td>
                            <td class=" text-end align-middle w-25">
                                <span class="fw-bold font-monospace">
                                    ${{ bill.amount | number:'1.0-0':'es-CL' }}
                                </span>
                            </td>
                        </tr>
                        }
                        }

                        @if(!isLoading() && hasLoadedPeriod() && filteredBillings().length === 0) {
                        <tr>
                            <td colspan="7" class="text-center p-5">
                                <div class="py-5">
                                    <i class="fas fa-receipt fa-4x text-light mb-3"></i>
                                    <h4 class="text-muted fw-normal">No hay cobros generados para este periodo</h4>
                                    <p class="text-muted small mb-0">Selecciona otro periodo".</p>
                                </div>
                            </td>
                        </tr>
                        }
                    </tbody>
                    <tfoot>
                        <tr>
                            @if(!isLoading() && filteredBillings().length > 0) {
                            <td colspan="6" style="text-align: right; font-weight: bold;">TOTAL DEL PERIODO:</td>
                            <td style="text-align: right; font-weight: bold;">{{ totalAmount() | number:'1.0-0':'es-CL' }}
                            </td>
                            }
                            @else {
                            <td colspan="7" class="text-center">
                            </td>
                            }
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    } @else {
        <!-- Vista Movil: Tarjetas ListCard -->
        <div class="col-12 mobile-billing-container">
            <!-- Barra de cabecera movil -->
            <div class="d-flex justify-content-between align-items-center mb-2 px-1">
                <span class="small text-muted fw-bold text-uppercase">
                    Registros @if(!isLoading()) { ({{ filteredBillings().length }}) }
                </span>
                @if (!isLoading() && filteredBillings().length > 0) {
                    <span class="small fw-bold font-monospace">${{ totalAmount() | number:'1.0-0':'es-CL' }}</span>
                }
            </div>

            <!-- Contenedor con scroll para tarjetas -->
            <div class="mobile-cards-scroll">
                @if(isLoading()) {
                    @for(i of [1,2,3,4]; track $index) {
                        <app-list-card [isLoading]="true"></app-list-card>
                    }
                } @else {
                    @for(bill of filteredBillings(); track bill.id) {
                        <app-list-card>
                            <div cardTitle class="fw-bold text-dark text-truncate">
                                {{ bill.party?.names || 'Sin nombre' }}
                            </div>
                            <div cardBadge>
                                <span class="badge bg-light text-dark border">{{ bill?.entityCode }}</span>
                            </div>

                            <!-- Ranura de acciones contextuales -->
                            <div cardActions>
                            </div>

                            <div class="row g-1">
                                <div class="col-6">
                                    <i class="fa fa-car me-1 text-muted"></i>
                                    <span class="fw-semibold text-dark">{{ bill.vehicle?.plate || 'S/P' }}</span>
                                </div>
                                <div class="col-6 text-end">
                                    <i class="fa fa-calendar me-1 text-muted"></i>
                                    <span>{{ bill.year }}/{{ bill.period | number:'2.0-0' }}</span>
                                </div>
                                @if(bill.vehicle?.commercialValue) {
                                    <div class="col-12 text-muted mt-1">
                                        Val. Comercial: ${{ bill.vehicle?.commercialValue | number:'1.0-0':'es-CL' }}
                                    </div>
                                }
                                @if(isBillingPartyAccounted(bill)) {
                                    <div class="col-12 mt-1">
                                        <span class="badge border bg-light text-success border-success" [title]="billingPartyAccountedTitle(bill)">Contabilizado</span>
                                    </div>
                                }
                            </div>

                            <div cardExtra>
                                <span class="text-muted text-uppercase fw-bold" style="font-size: 11px;">Prima</span>
                            </div>
                            <div cardAmount class="fw-bold font-monospace fs-14">
                                ${{ bill.amount | number:'1.0-0':'es-CL' }}
                            </div>
                        </app-list-card>
                    }

                    @if(hasLoadedPeriod() && filteredBillings().length === 0) {
                        <div class="card border-0 shadow-sm p-4 text-center">
                            <i class="fas fa-receipt fa-3x text-muted opacity-50 mb-2"></i>
                            <h6 class="text-muted mb-1">No hay cobros generados</h6>
                            <small class="text-muted">Ajusta los filtros o selecciona otro periodo.</small>
                        </div>
                    }
                }
            </div>

        </div>
    }

    @if(!isLoading() && filteredBillings()?.length > 0) {


    <table id="hidden-billing-table" style="display: none;">
        <thead>
            <tr class="bg-white">
                <th class="text-black">Entidad</th>
                <th class="text-black">Socio</th>
                <th class="text-black">Periodo</th>
                <th class="text-black">Patente</th>
                <th class="text-black" style="text-align: right;">Valor</th>
                <th class="text-black" style="text-align: right;">Prima</th>
            </tr>
        </thead>
        <tbody>
            @for(bill of filteredBillings(); track bill.id) {
            <tr>
                <td class="text-black">{{ bill.party?.entity?.code }}</td>
                <td class="text-black">{{ bill.party?.names }}</td>
                <td class="text-black">{{ bill.year }}/{{ bill.period | number:'2.0-0' }}</td>
                <td class="text-black">{{ bill.vehicle?.plate || 'S/P' }}</td>
                <td class="text-black" style="text-align: right;">{{ bill.vehicle?.commercialValue |
                    number:'1.0-0':'es-CL' }}</td>
                <td class="text-black" style="text-align: right;">{{ bill.amount | number:'1.0-0':'es-CL' }}</td>
            </tr>
            }
        </tbody>
        <tfoot>
            <tr class="bg-white">
                <td class="text-black" colspan="5" style="text-align: right; font-weight: bold;">TOTAL DEL PERIODO:</td>
                <td class="text-black" style="text-align: right; font-weight: bold;">{{ totalAmount() |
                    number:'1.0-0':'es-CL' }}</td>
                <td></td>
            </tr>
        </tfoot>
    </table>
    }
    <ng-template #preview let-c="close" let-d="dismiss" let-modal>
        <div class="modal-header">
            <a [href]="pdfSrc" class="btn btn-success btn-sm" target="_blank">Abrir en nueva pestaña</a>
            <span (click)="d('Cross click')" type="button" class="btn-close bt-xs" data-dismiss="modal"
                tabindex="8"></span>
        </div>
        <div class="modal-body">
            <iframe *ngIf="pdfSrc" [src]="pdfSrc" width="100%" height="600px" style="border: none;"></iframe>
        </div>
    </ng-template>

    <ng-template #apsMappingModal let-c="close" let-d="dismiss" let-modal>
        <div class="modal-header">
            <h5 class="modal-title"><i class="fas fa-users-cog me-2"></i> Configurar Subcuentas APS</h5>
            <button type="button" class="btn-close" (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body">
            <div class="row g-2 mb-3">
                <div class="col-md-6">
                    <label class="form-label small text-muted mb-1">Periodo cerrado</label>
                    <ng-select
                        [items]="closedPeriods()"
                        bindLabel="displayName"
                        bindValue="id"
                        [ngModel]="asinetPeriodId()"
                        (ngModelChange)="onAsinetPartyPeriodChange($event)"
                        [clearable]="false"
                        placeholder="Seleccione periodo cerrado">
                    </ng-select>
                </div>
                <div class="col-md-6">
                    <label class="form-label small text-muted mb-1">Entidad</label>
                    <ng-select
                        [items]="allEntities()"
                        bindLabel="name"
                        bindValue="code"
                        [ngModel]="asinetEntityCode()"
                        (ngModelChange)="onAsinetPartyEntityChange($event)"
                        [clearable]="false"
                        placeholder="Seleccione entidad">
                    </ng-select>
                </div>
            </div>

            @if(asinetPartyIsAccounted()) {
                <div class="alert alert-success d-flex align-items-center mb-2 py-2 px-3">
                    <i class="fas fa-check-circle me-2"></i>
                    <div><strong>Contabilizado:</strong> Las personas de esta entidad ya están marcadas.
                        Las demás entidades no se tocan.
                    </div>
                </div>
            } @else {
                <div class="alert alert-info d-flex align-items-center mb-2 py-2 px-3">
                    <i class="fas fa-info-circle me-2"></i>
                    <div>Contabilizar solo marca las personas de la entidad elegida. El resto queda pendiente.</div>
                </div>
            }

            <div class="d-flex justify-content-between p-2 mb-3">
                <p class="text-muted small mb-0">Valide o asigne las subcuentas APS para la exportación de Cobros.</p>
                <div>
                    @if(isEditingAps()) {
                        <button class="btn btn-sm btn-outline-success me-2" (click)="syncWithAps()" title="Forzar búsqueda en APS">
                            <i class="fas fa-sync-alt"></i> Sincronizar con APS
                        </button>
                    }
                    <button class="btn btn-sm btn-outline-primary" (click)="toggleEditAps()">
                        <i class="fas" [ngClass]="isEditingAps() ? 'fa-times' : 'fa-edit'"></i> 
                        {{ isEditingAps() ? 'Cancelar Edición' : 'Editar Subcuentas' }}
                    </button>
                </div>
            </div>

            @if(isAsinetPartyLoading()) {
                <div class="text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Cargando...</span>
                    </div>
                    <p class="text-muted small mt-2">Cargando cobros del periodo...</p>
                </div>
            } @else {
             <div class="col-12 mt-3 table-data mb-3">
            <table class="table table-sm table-hover">
                <thead>
                    <tr>
                        <th>Entidad</th>
                        <th>Socio</th>
                        <th>Patente</th>
                        <th class="text-center">Estado</th>
                        <th class="text-center" style="width: 200px;">Subcuenta</th>
                    </tr>
                </thead>
                <tbody>
                    @for(bill of asinetPartyBillings(); track bill.id) {
                    <tr>
                        <td class="align-middle">{{ bill.entityCode }}</td>
                        <td class="align-middle">{{ bill.party?.names }}</td>
                        <td class="align-middle">{{ bill.vehicle?.plate || 'S/P' }}</td>
                        <td class="align-middle text-center">
                            @if (isBillingPartyAccounted(bill)) {
                                <span class="badge bg-success" [title]="billingPartyAccountedTitle(bill)">Contabilizado</span>
                            } @else {
                                <span class="badge bg-secondary">Pendiente</span>
                            }
                        </td>
                        <td class="align-middle p-1">
                            @if(isEditingAps()) {
                                <input type="text" class="form-control form-control-sm text-center mb-1" 
                                    [ngModel]="tempApsMappings()[bill.party?.id]?.code ?? ''" 
                                    (ngModelChange)="tempApsMappings().hasOwnProperty(bill.party?.id) ? tempApsMappings()[bill.party?.id].code = $event : tempApsMappings()[bill.party?.id] = {code: $event, isSuggested: false, matchName: 'Manual'}" 
                                    placeholder="Ingrese subcuenta...">
                            } @else {
                                <div class="text-center w-100 fw-bold">{{ tempApsMappings()[bill.party?.id]?.code || '---' }}</div>
                            }
                            <div class="text-center" style="font-size: 0.7rem;" 
                                 [ngClass]="{'text-success': tempApsMappings()[bill.party?.id]?.isSuggested, 'text-muted': !tempApsMappings()[bill.party?.id]?.isSuggested}">
                                {{ tempApsMappings()[bill.party?.id]?.matchName || '' }}
                            </div>
                        </td>
                    </tr>
                    }
                    @if(asinetPartyBillings().length === 0) {
                    <tr>
                        <td colspan="5" class="text-center text-muted py-3">No hay cobros de personas para este periodo.</td>
                    </tr>
                    }
                </tbody>
            </table>
            </div>
            }
        </div>
        <div class="modal-footer">
            <button class="btn btn-secondary" (click)="d('Cancel')">Cerrar</button>
            @if(isEditingAps()) {
                <button class="btn btn-primary" (click)="saveBulkApsMapping(modal)">
                    <i class="fas fa-save me-1"></i> Guardar Configuración
                </button>
            } @else {
                @if (perm.hasCurrentAction('EXPORT_EXCEL')) {
                <button class="btn btn-primary" [disabled]="asinetPartyBillings().length === 0" (click)="exportAsinetPartyVehicle(modal)">
                    <i class="fas fa-download me-1"></i> Exportar Excel (Copia)
                </button>
                }
                @if (perm.hasCurrentAction('ACCOUNT_BILLING_ALL') && !asinetPartyIsAccounted()) {
                <button class="btn btn-success" [disabled]="asinetPartyBillings().length === 0 || isAsinetPartyLoading()" (click)="exportAndAccountParties(modal)">
                    <i class="fas fa-file-excel me-1"></i> Exportar y Contabilizar
                </button>
                }
            }
        </div>
    </ng-template>

    <ng-template #entityExportModal let-c="close" let-d="dismiss" let-modal>
        <div class="modal-header">
            <h5 class="modal-title"><i class="fas fa-building me-2"></i> Cobro Consolidado por Entidades</h5>
            <button type="button" class="btn-close" (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body">
            <div class="mb-3">
                <label class="form-label small text-muted mb-1">Periodo cerrado</label>
                <ng-select
                    [items]="closedPeriods()"
                    bindLabel="displayName"
                    bindValue="id"
                    [ngModel]="asinetPeriodId()"
                    (ngModelChange)="onAsinetEntityPeriodChange($event)"
                    [clearable]="false"
                    placeholder="Seleccione periodo cerrado">
                </ng-select>
            </div>

            @if(asinetPeriod()?.isEntityAccounted) {
                <div class="alert alert-success d-flex align-items-center mb-3 py-2 px-3">
                    <i class="fas fa-check-circle me-2"></i>
                    <div><strong>Contabilizado:</strong> El cobro a entidades fue contabilizado el {{ entityAccountedInfo()?.date }} por {{ entityAccountedInfo()?.user }}.</div>
                </div>
            } @else {
                <div class="alert alert-info d-flex align-items-center mb-3 py-2 px-3">
                    <i class="fas fa-info-circle me-2"></i>
                    <div>Periodo cerrado. Puede proceder a exportar y marcar como contabilizado en ASINET.</div>
                </div>
            }

            @if(isEntityBillingLoading()) {
                <div class="text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Cargando...</span>
                    </div>
                    <p class="text-muted small mt-2">Cargando cobros por entidad...</p>
                </div>
            } @else {
                <div class="col-12 mt-3 table-data mb-3">
                    <table class="table table-sm table-hover align-middle mb-0">
                        <thead class="table-light">
                            <tr>
                                <th style="width: 120px;">Código</th>
                                <th>Nombre de Entidad</th>
                                <th class="text-end" style="width: 180px;">Monto</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for(item of entityBillingItems(); track item.entityCode) {
                            <tr>
                                <td class="fw-bold">{{ item.entityCode }}</td>
                                <td>{{ item.entityName }}</td>
                                <td class="text-end fw-semibold">${{ item.amount | number:'1.0-0':'es-CL' }}</td>
                            </tr>
                            }
                            @if(entityBillingItems().length === 0) {
                            <tr>
                                <td colspan="3" class="text-center text-muted py-3">No hay cobros de entidades para este periodo.</td>
                            </tr>
                            }
                        </tbody>
                        @if(entityBillingItems().length > 0) {
                        <tfoot class="table-light fw-bold">
                            <tr>
                                <td colspan="2" class="text-uppercase text-muted">Total General Periodo</td>
                                <td class="text-end text-primary fs-6">${{ entityBillingTotal() | number:'1.0-0':'es-CL' }}</td>
                            </tr>
                        </tfoot>
                        }
                    </table>
                </div>
            }
        </div>
        <div class="modal-footer">
            <button class="btn btn-secondary" (click)="d('Cancel')">Cerrar</button>
            @if (perm.hasCurrentAction('EXPORT_EXCEL')) {
                <button class="btn btn-primary" [disabled]="entityBillingItems().length === 0" (click)="exportEntitiesOnly(modal)">
                    <i class="fas fa-download me-1"></i> Exportar Excel (Copia)
                </button>
            }
            @if (perm.hasCurrentAction('ACCOUNT_BILLING_ALL') && !asinetPeriod()?.isEntityAccounted) {
                <button class="btn btn-success" [disabled]="entityBillingItems().length === 0 || isEntityBillingLoading()" (click)="exportAndAccountEntities(modal)">
                    <i class="fas fa-file-excel me-1"></i> Exportar y Contabilizar
                </button>
            }
        </div>
    </ng-template>